/* ==============================================================================================
 *==============================================================================================
 * INTIALIZE DATEPICKER INSTANCES
 * ============================================================================================== */

var Sushi, $ = window.jQuery;

(function (Sushi) {
	"use strict";

	$.fn.datepicker.dates.en.daysMin = ["S", "M", "T", "W", "T", "F", "S"];

	var timeout;
	var isOpened = false;

	/**
	 * @param {Event} event
	 * @return void
	 */
	function handleVisibility(event) {
		var inputEl = event.currentTarget;
		var datepicker = inputEl.parentNode.querySelector(".datepicker");
		var container = inputEl.parentNode.querySelector(".datepicker-container");

		if (event.type === "show") {
			var boundX = inputEl.closest("[data-element-bound-x]");
			var boundY = inputEl.closest("[data-element-bound-y]");

			if (isOpened || !boundX || !boundY) {
				return;
			}

			isOpened = true;

			datepicker.style = {};
			container.style = {};
			container.style.position = "absolute";
			container.style.left = "-1px";

			container.classList.add("datepicker--visible");

			setTimeout(function () {
				var visualGapHorizontal = 9;

				var boundXRect = boundX.getBoundingClientRect();
				var boundXOffset = boundXRect.left + boundXRect.width;

				var boundYRect = boundY.getBoundingClientRect();

				var datepickerRect = datepicker.getBoundingClientRect();
				var datepickerOffsetX = datepickerRect.left + datepickerRect.width;

				var datepickerOverlapsHorizontally = datepickerOffsetX > boundXOffset;
				var datepickerOverlapsVertically = datepickerRect.top + datepickerRect.height
					> boundYRect.bottom;

				var newXPosition;

				if (timeout) {
					clearTimeout(timeout);
				}

				if (datepickerOverlapsHorizontally) {
					newXPosition = (datepickerOffsetX - boundXOffset) * -1
						+ visualGapHorizontal;

					container.classList.remove("datepicker--left");
					container.classList.add("datepicker--right");
				}
				else {
					newXPosition = visualGapHorizontal * -1;
					container.classList.remove("datepicker--right");
					container.classList.add("datepicker--left");
				}

				container.style.left = newXPosition + "px";

				if (datepickerOverlapsVertically) {
					container.style.bottom = inputEl.offsetHeight + "px";
					container.classList.remove("datepicker--bottom");
					container.classList.add("datepicker--top");
				}
				else {
					container.classList.remove("datepicker--top");
					container.classList.add("datepicker--bottom");
				}

				container.classList.add("datepicker--active");
			}, 1);
		}
		else {
			container.classList.remove("datepicker--visible");
			isOpened = false;
		}
	}

	/**
	 * @return void
	 */
	function handleChange(event) {
		var container = event.currentTarget.parentNode.querySelector(".datepicker-container");

		container.classList.remove("datepicker--visible");

		setTimeout(function () {
			$(this).datepicker("hide");
		}.bind(this), 300);

		setTimeout(function () {
			Sushi.Events(this).trigger("change");
		}.bind(this), 1);
	}

	/**
	 * @param {Element} parentElement
	 * @return void
	 */
	function initDatepickers(parentElement) {
		$(parentElement.querySelectorAll("[data-datepicker]")).each(function () {
			var dtConfig = {
				container: $("<div class=\"datepicker-container\"></div>")
					.appendTo($(this).parent()),
				templates: {
					leftArrow: "<span>&lt;</span>",
					rightArrow: "<span>&gt;</span>",
				},
				maxViewMode: "years",
			};

			if ($(this).data("datepicker-format")) {
				Object.assign(dtConfig, {
					format: $(this).data("datepicker-format"),
				});
			}

			if ($(this).data("datepicker-min-view")) {
				Object.assign(dtConfig, {
					minViewMode: $(this).data("datepicker-min-view"),
				});
			}

			if ($(this).data("datepicker-max-view")) {
				Object.assign(dtConfig, {
					maxViewMode: $(this).data("datepicker-max-view"),
				});
			}

			if (Sushi.Util.isMobile()) {
				$(this).mask(dtConfig.format === "yyyy" ? "0000" : "00/00/0000", {
					selectOnFocus: true,
				});

				return;
			}

			$(this).datepicker(dtConfig).on("show", handleVisibility);
			$(this).datepicker(dtConfig).on("hide", handleVisibility);
			$(this).datepicker(dtConfig).on("changeDate", handleChange);
		});
	}

	initDatepickers(document);

	/* Repeaters */
	Sushi.Events(document).on("Repeater.add", function (event) {
		initDatepickers(event.target);
	});
})(Sushi || (Sushi = {}));
